export default "__VITE_ASSET__DoBATnti__"